module.exports = __webpack_public_path__ + "img/Vision_icd.120a1efc.svg";